









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

const components = {
  NewNominator: () => import('./NewNominator.vue'),
  NewValidator: () => import('./NewValidator.vue'),
  NewStash: () => import('./NewStash.vue')
};

@Component({ components })
export default class ElectionBanner extends Vue {
  @Prop() private targetValidatorIds!: string[];
}
